import UtilityService from '../services/utility.service';
import DataService from '../services/data.service';

export class SolubilityRulesComponent {
    constructor() {
        this.componentName = "solubilityRulesComponent";
        this.template = `
            <h3>Solubility Rules Results</h3>
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col">Month</th>
          <th scope="col">Total</th>
        </tr>
      </thead>
      <tbody id="data_row">
        <tr class="table-default">
          <td scope="row">January 2020</td>
          <td>100</td>
        </tr>
      </tbody>
    </table>
        `;
        
        this.rowTemplate = `
        <tr class="table-default">
          <td scope="row">{MonthYear}</td>
          <td>{Count}</td>
        </tr>
        `;
        this.cache = undefined;
		this.cacheExpiration = undefined;
    }

	
	render() {
        _svc.common.renderResults("SolubilityRules", _cmp.solubilityRules);
    }
    
	postBackSuccess(data) {
      _svc.common.populateDataRows(data, _cmp.solubilityRules.rowTemplate, _cmp.solubilityRules.componentName, _cmp.solubilityRules.template);
      _svc.common.handleCache(_cmp.solubilityRules);
	}
	
	postBackFailed() {
		_svc.util.clear("#" + _cmp.solubilityRules.componentName);
	}
	
	cacheExpired() {
		if (_cmp.solubilityRules.cacheExpiration == undefined) return true;
		if (_cmp.solubilityRules.cache == undefined) return true;
		return _cmp.solubilityRules.cacheExpiration < _svc.util.now();
	}
};

setTimeout(() => {
    _cmp.solubilityRules = new SolubilityRulesComponent();
}, 1);